(() => {
  function destination(hash) {
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch { return null; }
    const target = document.getElementById(id);
    return target?.hasAttribute('data-discovery-target') ? target : null;
  }

  function focusDestination(target, scroll = false) {
    if (scroll) target.scrollIntoView({behavior: 'instant', block: 'start'});
    target.querySelector('h2').focus({preventScroll: true});
  }

  async function navigate(event, owner) {
    if (event.defaultPrevented || event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || !owner.contains(link) || link.target || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
    // A menu link without a query keeps the current alternate-template preview.
    if (url.search && url.search !== location.search) return;
    const target = destination(url.hash);
    if (!target) return;
    event.preventDefault();
    const startedAt = location.href;
    const navigation = owner.discoveryNavigation = (owner.discoveryNavigation || 0) + 1;
    const drawer = owner.closest('side-drawer');
    if (drawer?.classList.contains('open')) {
      await drawer.close({restoreFocus: false});
      if (drawer.classList.contains('open') || location.href !== startedAt || owner.discoveryNavigation !== navigation) return;
    }
    if (location.hash !== url.hash) {
      const next = new URL(location.href);
      next.hash = url.hash;
      history.pushState(history.state, '', next.href);
    }
    focusDestination(target, true);
  }

if (!customElements.get('hatchill-discovery-menu')) {
  customElements.define('hatchill-discovery-menu', class extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => navigate(event, this);
      this.onKey = (event) => {
        if (event.key !== 'Escape') return;
        const open = event.target.closest('details[open]');
        if (!open || !this.contains(open)) return;
        event.preventDefault();
        event.stopPropagation();
        this.handledEscape = true;
        open.open = false;
        open.querySelector('summary').focus();
      };
      this.onToggle = (event) => {
        if (!event.target.open) return;
        for (const other of this.querySelectorAll('details[open]')) {
          if (other !== event.target) other.open = false;
        }
      };
      this.onKeyUp = (event) => {
        if (event.code === 'Escape' && this.handledEscape) {
          event.stopPropagation();
          this.handledEscape = false;
        }
      };
      this.addEventListener('keydown', this.onKey);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keyup', this.onKeyUp);
      this.addEventListener('toggle', this.onToggle, true);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      this.removeEventListener('keyup', this.onKeyUp);
      this.removeEventListener('toggle', this.onToggle, true);
    }
  });
}

if (!customElements.get('hatchill-discovery-hub')) {
  customElements.define('hatchill-discovery-hub', class extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => navigate(event, this);
      this.onHistory = () => {
        const target = destination(location.hash);
        if (target) focusDestination(target);
        else if (!location.hash) this.querySelector('h1').focus({preventScroll: true});
      };
      this.onArrival = () => {
        const target = destination(location.hash);
        if (target && (!document.activeElement || document.activeElement === document.body)) focusDestination(target, true);
      };
      // Native fragment navigation can reset focus after DOMContentLoaded.
      // Wait until the page is shown, and never interrupt a visitor who has
      // already focused another control while the page was loading.
      this.onPageShow = () => {
        this.arrivalFrame = requestAnimationFrame(() => {
          this.arrivalFrame = null;
          if (this.isConnected) this.onArrival();
        });
      };
      this.addEventListener('click', this.onClick);
      window.addEventListener('popstate', this.onHistory);
      window.addEventListener('hashchange', this.onHistory);
      window.addEventListener('pageshow', this.onPageShow);
      if (document.readyState === 'complete') this.onPageShow();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('popstate', this.onHistory);
      window.removeEventListener('hashchange', this.onHistory);
      window.removeEventListener('pageshow', this.onPageShow);
      if (this.arrivalFrame) cancelAnimationFrame(this.arrivalFrame);
      const chatHost = this.querySelector('[data-discovery-chat-slot] [data-chatcast-website]');
      if (chatHost && document.body) {
        chatHost.shadowRoot?.querySelector('[data-hatchill-launcher-anchor]')?.remove();
        document.body.appendChild(chatHost);
      }
    }
  });
}
})();
